import React from "react";
import dynamic from "next/dynamic";
import ModalCommon from "../Modal/ModalCommon/ModalCommon";
import CircleLoader from "../Loader/CircleLoader";
import styles from "../PtEditor/ReportWrite/ReportWrite.module.scss";

const Viewer = dynamic(
  () => import("@toast-ui/react-editor").then((c) => c.Viewer),
  {
    ssr: false,
    loading: () => {
      return (
        <div className={styles.loader} style={{ height: "700px" }}>
          <CircleLoader />
          Loading...
        </div>
      );
    },
  },
);

const Policy = ({ setModalOpen, data }) => {
  return (
    <ModalCommon
      title="개인정보처리방침"
      setModalOpen={setModalOpen}
      center
      darkBg
      style={{ maxHeight: 500, overflowY: "auto" }}
    >
      <div style={{ backgroundColor: "#fff", width: "840px" }}>
        <Viewer initialValue={data.Content} />
      </div>
    </ModalCommon>
  );
};

export default Policy;
